import api from "../api";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { toastStyles } from "../styles/styles";
import { useTheme } from "../context/ThemeProvider";

const useToggleBlockUser = () => {
    const { theme } = useTheme();
    const { mutate: toggleBlockUser, isLoading: isTogglingBlock } = useMutation({
        mutationFn: (userId) => api.users.toggleBlockUser(userId),
        onSuccess: () => {
            toast.success('User blocked successfully', { ...toastStyles, theme: theme });
        },
        onError: () => {
            toast.error('Failed to block user', { ...toastStyles, theme: theme });
        }
    });

    return { toggleBlockUser, isTogglingBlock };
};

export default useToggleBlockUser;
